export default __webpack_public_path__ + "static/stratton-logo-700d50bd3219a64c1ae3a1fad4a94bf1.png";